import { useEffect, useState } from 'react';
import { Plan, useCurrentAgreement } from '@economic/react-app';

/*
This value should be fetched from the API to avoid having descrepencies between the client and the API.
However, this entire check is going to be refactored in the near future when inventory has been fully deprecated.
*/
export const useHasGraveyardFeaturePermission = () => {
    const agreement = useCurrentAgreement();
    const [hasAccess, setHasAccess] = useState<boolean | undefined>(undefined);

    useEffect(() => {
        const planLevel = agreement?.subscription?.level;
        const planId = agreement?.subscription?.id;
        setHasAccess(
            planLevel === Plan.Smart ||
                planLevel === Plan.Advanced ||
                planLevel === Plan.Plus ||
                planId === 138 || // Internal plus
                planId === 156 || // Internal advanced micro
                planId === 157 // Internal advanced
        );
    }, [agreement]);

    return hasAccess;
};
